import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd'
import { FACTURA, COTIZACION } from '../../../../common/types/tipoComprobanteType';
import { INCREMENTO_PV, VENTA_PRECIO_UNITARIO_INCLUYE_IGV } from '../../../../common/types/parametroType';

import auth from "../../../../common/utility/auth";

const InputGroup = Input.Group;
const { Option } = Select;

export default function Footer(props) {

    var params = auth.user().parametros;
    const impresionVU = params.filter(m => m.abreviatura === INCREMENTO_PV)[0].valor === "1" ? true : false;
    const flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

    return (
        <div className="row">
            <div className={"col-md-9"}>
                <Form.Item>
                    <InputGroup compact>

                        {
                            props.formValues.idTipoComprobante === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {
                                        props.onGetFieldDecorator('flagExportacion', {
                                            initialValue: props.formValues.flagExportacion,
                                            valuePropName: 'checked'
                                        })(<Checkbox>Exportación</Checkbox>)
                                    }
                                </Form.Item> : null
                        }

                        {
                            props.formValues.idTipoComprobante === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagPercepcion', {
                                        initialValue: props.formValues.flagPercepcion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagPercepcion", e.target.checked)}
                                        >
                                            Percepción
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                        {
                            props.formValues.idTipoComprobante === COTIZACION.ID && impresionVU ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagImpresion', {
                                        initialValue: props.formValues.flagImpresion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagImpresion", e.target.checked)}
                                        >
                                            {flagPrecioIncluyeIGV ? "Impresión V.U" : "Impresión P.U"}

                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }

                        {
                            props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                                <Form.Item label="">
                                    {props.onGetFieldDecorator('idDetraccion', {
                                        initialValue: props.formValues.idDetraccion ?
                                            { key: props.formValues.idDetraccion } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Detracción"}
                                            optionFilterProp="children"
                                            onChange={(item, element) => props.onChangeTotals("idDetraccion", element.props.data.porcentaje)}
                                        >
                                            {props.formValues.detracciones.map(item => (
                                                <Option
                                                    key={item.id}
                                                    value={item.id}
                                                    data={item}
                                                >{item.codigoSunat + " - " + item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item> : null
                        }
                    </InputGroup>
                </Form.Item>
            </div>

            <div className="col-md-3 pt-10">
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5" >
                            <div className="total-inline">
                                <label>Porcentaje Percepción</label>
                                <div>{props.onGetFieldValue('porcentajePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Porcentaje Detracción</label>
                                <div>{props.onGetFieldValue('porcentajeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.onGetFieldValue('sumaTotalDetalle').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Descuento</label>
                        <div>{props.onGetFieldValue('sumaImporteDescuento').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.onGetFieldValue('sumaIgv').toFixed(2) === "-0.00" ? "0.00" : props.onGetFieldValue('sumaIgv').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>ISC</label>
                        <div>{props.onGetFieldValue('sumaIsc').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Persección</label>
                                <div>{props.onGetFieldValue('importePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Percepción</label>
                                <div>{props.onGetFieldValue('totalPercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Detracción</label>
                                <div>{props.onGetFieldValue('importeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Detracción</label>
                                <div>{props.onGetFieldValue('totalDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
            </div>
        </div>
    );
}